import { motion } from 'framer-motion';
import type { PropsWithChildren } from 'react';

export function AnimateContentPresenceWrapper({
    children,
}: PropsWithChildren<{}>) {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
        >
            {children}
        </motion.div>
    );
}
